import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as SearchSelectors from './search.selectors';
import * as SearchActions from './search.actions';
import { Observable } from 'rxjs';
import { SearchSortState } from './search.models';
import { SearchTarget, SortOrder } from '@cpak/adp-cpak-bff-service-models';

@Injectable()
export class SearchFacade {
  constructor(private readonly store: Store) {}

  getSortingStateForTarget(target: SearchTarget): Observable<SearchSortState> {
    return this.store.pipe(select(SearchSelectors.getSortingStateForTarget(target)));
  }

  updateSortingForTarget(target: SearchTarget, sort: string, sortOrder: SortOrder): void {
    this.store.dispatch(SearchActions.updateSearchSort({ target, sort, sortOrder }));
  }

  resetSortingState(): void {
    this.store.dispatch(SearchActions.resetSearchSort({ target: SearchTarget.accounts }));
    this.store.dispatch(SearchActions.resetSearchSort({ target: SearchTarget.paks }));
    this.store.dispatch(SearchActions.resetSearchSort({ target: SearchTarget.products }));
  }
}
